<script lang="ts" setup>
    import { useI18n } from 'vue-i18n';

    const { t } = useI18n();
    const infoDialog = ref<boolean>(false);

    const open = (): void => {
        infoDialog.value = true;
    };

    onMounted((): void => {
        console.log('Component app-menuAccountDepositDialog mounted.');
    });

    defineExpose({ open });
</script>
<template>
    <v-layout>
        <v-dialog v-model="infoDialog" width="auto" :scrim="false">
            <v-card class="pa-3">
                <v-card-title class="py-1 pl-3 pr-1" style="height: 48px">
                    <span class="text-h5">{{ t('menu.info') }}</span>
                    <v-spacer></v-spacer>
                </v-card-title>
                <v-card-text class="font16 px-7 py-2" v-html="t('agent.depositNotification')"></v-card-text>

                <v-card-actions class="pb-0 pl-0 pr-2">
                    <v-spacer></v-spacer>
                    <v-btn tag="a" color="lightBlack" variant="text" @click="infoDialog = false">
                        {{ t('action.ok') }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-layout>
</template>
<style scoped></style>
